import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const stats = [
    { value: '25+', label: 'Years Experience' },
    { value: '500+', label: 'Tons Exported Annually' },
    { value: '35+', label: 'Countries Served' },
    { value: '99.8%', label: 'Quality Approval Rate' },
  ];

  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity',
      description: 'We uphold the highest ethical standards in all our business dealings and partnerships.',
    },
    {
      icon: 'ri-award-line',
      title: 'Quality',
      description: 'Uncompromising commitment to delivering premium products that exceed international standards.',
    },
    {
      icon: 'ri-eye-line',
      title: 'Transparency',
      description: 'Open and honest communication with all stakeholders throughout our supply chain.',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sustainability',
      description: 'Responsible farming practices that protect our environment for future generations.',
    },
  ];

  const certifications = [
    'Global GAP Certified',
    'ISO 22000:2018',
    'HACCP Certified',
    'Egyptian Export Council Member',
    'National Food Safety Whitelist',
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[50vh] min-h-[300px] md:min-h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Egyptian%20agricultural%20landscape%20with%20lush%20green%20fields%20and%20palm%20trees%20near%20Nile%20River%20golden%20hour%20lighting%20professional%20landscape%20photography%20stunning%20scenery&width=1920&height=800&seq=300&orientation=landscape"
            alt="Egyptian Agricultural Landscape"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-emerald-900/70 via-emerald-900/50 to-emerald-900/80"></div>
        </div>
        <div className="relative z-10 text-center px-4 w-full max-w-4xl mx-auto">
          <span className="inline-block px-4 py-1.5 bg-emerald-500/20 backdrop-blur-sm text-emerald-300 text-xs md:text-sm font-medium rounded-full mb-4 md:mb-6">
            Our Story
          </span>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6">
            About <span className="bg-gradient-to-r from-emerald-400 via-teal-400 to-emerald-400 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Al-Amein</span>
          </h1>
          <p className="text-sm md:text-lg text-white/80 max-w-2xl mx-auto px-4">
            Leading Egyptian agricultural exports with 25+ years of excellence in quality and service.
          </p>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="space-y-4 md:space-y-6 order-2 lg:order-1">
              <span className="text-emerald-600 text-xs md:text-sm font-semibold uppercase tracking-wider">
                Who We Are
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
                Pioneering Egyptian{' '}
                <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Agricultural Excellence</span>
              </h2>
              <div className="space-y-3 md:space-y-4 text-sm md:text-base text-gray-600 leading-relaxed">
                <p>
                  Al-Amein is recognized as a leading import and export company fully focused on the international supply and distribution of Egypt&apos;s finest fresh fruits and vegetables. The company demonstrates a strong and consistent commitment to food safety, clearly reflected in its prestigious inclusion on the National Food Safety Whitelist, which guarantees the highest standards of quality throughout all stages of its operations.
                </p>
                <p>
                  In addition, Al-Amein is a respected member of the Egyptian Export Council, where it actively supports and promotes the export of Egyptian agricultural products, highlighting their quality and competitiveness in global markets.
                </p>
                <p>
                  Through an uncompromising focus on excellence and the development of strategic partnerships, Al-Amein has successfully positioned itself at the forefront of the global fresh produce sector, earning a solid reputation as a trusted and influential player in the industry.
                </p>
              </div>
              <Link
                to="/products"
                className="inline-flex items-center gap-2 px-5 md:px-6 py-2.5 md:py-3 text-white text-xs md:text-sm font-semibold rounded-full relative overflow-hidden group whitespace-nowrap"
              >
                <span className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_100%] animate-gradient-move"></span>
                <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                <span className="relative z-10 flex items-center gap-2">
                  Explore Our Products
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
            <div className="relative order-1 lg:order-2">
              <div className="relative rounded-2xl md:rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="/logo/ALAMIN.jpg "
                  alt="Al-Amein Agricultural Products"
                  className="w-full h-auto object-cover"
                />
              </div>
              {/* Experience Badge */}
              <div className="absolute -bottom-4 -left-4 md:-bottom-8 md:-left-8 rounded-2xl md:rounded-3xl p-4 md:p-8 shadow-2xl hidden sm:block relative overflow-hidden">
                <span className="absolute inset-0 bg-gradient-to-br from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_200%] animate-gradient-move"></span>
                <div className="text-center relative z-10 text-white">
                  <div className="text-3xl md:text-5xl font-bold mb-1 md:mb-2">25+</div>
                  <div className="text-xs md:text-sm font-medium text-white/80">
                    Years Of Excellence
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {/* Vision */}
            <div className="bg-white/80 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg border border-gray-100">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-xl md:rounded-2xl mb-4 md:mb-6 relative overflow-hidden cursor-pointer">
                <span className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-teal-500 to-emerald-500 bg-[length:200%_200%] animate-gradient-move"></span>
                <i className="ri-eye-line text-xl md:text-2xl text-white relative z-10"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                Our <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Vision</span>
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Our vision is to position Al-Amein as a global benchmark for Egyptian agricultural exports. We aim to elevate the reputation of Egyptian produce through quality leadership and sustainable growth. By embracing innovation and global standards, we seek long-term market presence. Excellence is the future we build toward.
              </p>
            </div>

            {/* Mission */}
            <div className="bg-white/80 backdrop-blur-md rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg border border-gray-100">
              <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-xl md:rounded-2xl mb-4 md:mb-6 relative overflow-hidden cursor-pointer">
                <span className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-teal-500 to-emerald-500 bg-[length:200%_200%] animate-gradient-move"></span>
                <i className="ri-flag-line text-xl md:text-2xl text-white relative z-10"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 md:mb-4">
                Our <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Mission</span>
              </h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Al-Amein&apos;s mission is to deliver premium agricultural products that meet international quality and food safety standards. We strive to create value through responsible farming, efficient supply chains, and trusted partnerships. Customer satisfaction and reliability guide every decision. Our mission reflects our commitment to global excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 md:py-16 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-600 bg-[length:200%_100%] animate-gradient-move"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-2xl sm:text-4xl md:text-5xl font-bold text-white mb-1 md:mb-2">
                  {stat.value}
                </div>
                <div className="text-emerald-100/80 text-xs md:text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10 md:mb-16">
            <span className="inline-block px-4 py-1.5 bg-emerald-100 text-emerald-600 text-xs md:text-sm font-medium rounded-full mb-3 md:mb-4">
              Our Core Values
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
              What Drives{' '}
              <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Our Success</span>
            </h2>
            <p className="text-sm md:text-base text-gray-600 mt-3 md:mt-4 max-w-2xl mx-auto">
              Integrity, quality, transparency, and sustainability define Al-Amein&apos;s core values. We believe in ethical business practices and long-term partnerships. Our values drive consistency in product quality and service reliability.
            </p>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white/80 backdrop-blur-md rounded-xl md:rounded-2xl p-5 md:p-8 shadow-md hover:shadow-xl transition-all duration-300 text-center group border border-gray-100"
              >
                <div className="w-12 h-12 md:w-16 md:h-16 flex items-center justify-center rounded-xl md:rounded-2xl mx-auto mb-4 md:mb-6 relative overflow-hidden cursor-pointer">
                  <span className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-teal-500 to-emerald-500 bg-[length:200%_200%] animate-gradient-move"></span>
                  <span className="absolute inset-0 bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                  <i
                    className={`${value.icon} text-xl md:text-2xl text-white relative z-10`}
                  ></i>
                </div>
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-2 md:mb-3">
                  {value.title}
                </h3>
                <p className="text-gray-600 text-xs md:text-sm">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Agricultural Investment Strategy */}
      <section className="py-12 md:py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="relative order-2 lg:order-1">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20agricultural%20investment%20Egyptian%20farm%20with%20advanced%20irrigation%20systems%20professional%20photography%20aerial%20view%20green%20fields%20technology&width=600&height=500&seq=701&orientation=landscape"
                alt="Agricultural Investment"
                className="w-full h-auto rounded-2xl md:rounded-3xl shadow-2xl"
              />
            </div>
            <div className="space-y-4 md:space-y-6 order-1 lg:order-2">
              <span className="text-emerald-600 text-xs md:text-sm font-semibold uppercase tracking-wider">
                Investment Strategy
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
                Agricultural{' '}
                <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Investment Strategy</span>
              </h2>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Al-Amein actively invests in agricultural projects to ensure control over quality and supply stability. Our investment approach focuses on high-yield crops and modern farming methods. This strategy allows us to meet international demand consistently. Long-term growth is at the heart of our investments.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">
            <div className="relative order-2 lg:order-1">
              <img
                src="https://readdy.ai/api/search-image?query=Quality%20control%20laboratory%20in%20modern%20agricultural%20facility%20scientists%20inspecting%20fresh%20produce%20professional%20photography%20clean%20environment%20certification%20process&width=600&height=500&seq=301&orientation=landscape"
                alt="Quality Control"
                className="w-full h-auto rounded-2xl md:rounded-3xl shadow-2xl"
              />
            </div>
            <div className="space-y-4 md:space-y-6 order-1 lg:order-2">
              <span className="text-emerald-600 text-xs md:text-sm font-semibold uppercase tracking-wider">
                Quality Assurance
              </span>
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
                Certified{' '}
                <span className="bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_auto] animate-gradient-text bg-clip-text text-transparent">Excellence</span>
              </h2>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                Our commitment to quality is backed by internationally recognized certifications and memberships that ensure every product meets the highest standards.
              </p>
              <div className="space-y-3 md:space-y-4">
                {certifications.map((cert, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-emerald-50 rounded-lg md:rounded-xl"
                  >
                    <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full flex-shrink-0 relative overflow-hidden">
                      <span className="absolute inset-0 bg-gradient-to-r from-emerald-500 via-teal-500 to-emerald-500 bg-[length:200%_100%] animate-gradient-move"></span>
                      <i className="ri-check-line text-white relative z-10"></i>
                    </div>
                    <span className="font-medium text-gray-900 text-sm md:text-base">{cert}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 md:py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-emerald-600 via-teal-600 to-emerald-600 bg-[length:200%_100%] animate-gradient-move"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-64 md:w-96 h-64 md:h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
          <div className="absolute bottom-0 right-0 w-64 md:w-96 h-64 md:h-96 bg-white rounded-full translate-x-1/2 translate-y-1/2"></div>
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4 md:mb-6">
            Ready to Partner with Us?
          </h2>
          <p className="text-sm md:text-lg text-white/80 mb-6 md:mb-8">
            Join our network of satisfied importers and distributors worldwide.
          </p>
          <Link
            to="/contact"
            className="inline-block px-6 md:px-8 py-3 md:py-4 bg-white text-emerald-600 text-sm md:text-base font-semibold rounded-full hover:shadow-xl transition-all duration-300 whitespace-nowrap"
          >
            Get in Touch
          </Link>
        </div>
      </section>
    </Layout>
  );
}